import { useState } from "react";
import { BottomSheet } from "../BottomSheet";
import { Footer } from "../Footer";
import { Video } from "../Video";
import "./style.css";

export const Main = () => {
  const [isOpenBottomSheet, setIsOpenBottomSheet] = useState(false);

  const handleOpenBottomSheet = () => {
    setIsOpenBottomSheet(true);
  };

  return (
    <main className="main__container">
      <img className="main__header" src="images/header.png" alt="" />
      <Video />
      <Footer handleOpenBottomSheet={handleOpenBottomSheet} />
      <div className="gradient" />
      <BottomSheet isOpen={isOpenBottomSheet} setOpen={setIsOpenBottomSheet} />
    </main>
  );
};
